// import { ArrowLeftOutlined } from '@ant-design/icons';
import { Form, Input, message, Radio, Spin } from 'antd';
import { Rule } from 'antd/lib/form';
//import { useEffect, useState, useRef } from 'react';
import { useEffect, useState } from 'react';
import { getNachBankDetails, nachBankDetailType } from 'api/nach';
import { useIfscValidator } from 'features/nach/hooks/useIfscValidator';
import { handleOnlyDgit } from 'features/nach/utils/handleOnlyDigit';
// import axios from 'axios'; // Added axios import for network validation

// import { getAccountValidationRules } from 'features/nach/utils/accountValidation'; // Imported validator helper

type Props = {
  checkedRecord?: any;
  title?: string;
  nachBankData?: nachBankDetailType;
  setNachBankData?: (data: nachBankDetailType) => void;
  form?: any;
  nachId: number;
  setEnachBankCode: (code: string) => void;
  setBranckName: (name: string) => void;
  sourceType: string; // Added to capture selection from SourceTypeChoose
};
function BankDetails({
  setNachBankData,
  nachBankData,
  form,
  nachId,
  setEnachBankCode,
  setBranckName,
  sourceType, // Destructured here
}: Props) {
  const [bankNameList, setBankNameList] = useState<string[]>([]);
  console.log('[BankDetails] Render triggered. Incoming props ->', { nachId, sourceType, hasForm: !!form });

  // console.log('');

  const {
    branchName,
    setIfscCode,
    ifscError,
    bankName: bankName1,
    bankCode,
    isLoading,
  } = useIfscValidator(nachBankData?.ifsc as string);

  // Persistent reference box to keep the debounce timer valid across keystroke re-renders
  // const validationTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  // // Debounced API worker matching your backend tunnel layout precisely
  // const checkAccountLengthWithBackend = (id: number, currentLength: number): Promise<{ isValid: boolean; minLength: number }> => {
  //   return new Promise((resolve) => {
  //     if (validationTimeoutRef.current) {
  //       clearTimeout(validationTimeoutRef.current);
  //     }

  //     validationTimeoutRef.current = setTimeout(async () => {
  //       const url = `https://ppapiepayment.avanse.com/api/avanse/nachmodule/payment-config/validate-length?nachId=${id}&length=${currentLength}`;
  //       console.log(`[Debounced Request] Sending validation payload -> URL: ${url}`);

  //       try {
  //         const response = await axios.get(url);
  //         console.log("[API Response Success] Data received from backend:", response.data);
  //         resolve(response.data);
  //       } catch (error) {
  //         console.error("Backend validation failed during debounce cycle:", error);
  //         resolve({ isValid: true, minLength: 7 }); // Safe operational default fallback
  //       }
  //     }, 500);
  //   });
  // };

  useEffect(() => {
    if (bankCode) {
      // Check if setBankCode is defined
      setEnachBankCode(bankCode);
    }
  }, [bankCode]);

  useEffect(() => {
    if (branchName) {
      // Check if setBankCode is defined
      setBranckName(branchName);
    }
  }, [branchName]);

  const required: Rule[] = [
    {
      type: 'string',
      required: true,
      transform(value) {
        return value.trim();
      },
    },
  ];

  // CHANGE 1: Added [nachId] so it re-triggers safely if the user swaps ID context
  useEffect(() => {
    // Safeguard: If nachId is missing, 0, or invalid, stop right here! Don't call the server.
    if (!nachId || nachId <= 0) {
      console.warn("Bypassing getNachBankDetails fetch: nachId is invalid or empty.", nachId);
      setBankNameList([]);
      return;
    }
    getNachBankDetails({ nachId: nachId }).then((res) => {
      console.log('[BankDetails] API response received for getNachBankDetails:', res);
      if (res && res.status === 'SUCCESS' && Array.isArray(res.data)) {
        // Clean up data map structure to remove undefined fields safely
        const filteredBankNames = res.data.map((item) => item?.bankName).filter(Boolean);
        console.log('[BankDetails] Master list compiled successfully. Records found:', filteredBankNames.length, filteredBankNames);
        setBankNameList(filteredBankNames);
      } else {
        setBankNameList([]);
      }
    })
      // ───> ADD THE CODE BELOW HERE <───
      .catch((error) => {
        console.error("Gracefully caught server error inside getNachBankDetails:", error);
        setBankNameList([]); // Reset state to safe empty list so form remains stable
      });
  }, [nachId]);

  useEffect(() => {
    const isEditable = nachBankData?.editable ? nachBankData.editable : false;
    const nachtype = nachBankData?.nachtype ? nachBankData.nachtype : '';
    const accountType = nachBankData?.accountType ? nachBankData.accountType : '';
    const accountNumber = nachBankData?.accountNumber ? nachBankData.accountNumber : '';
    const branchName = nachBankData?.branchName ? nachBankData.branchName : '';
    const accountHolderName = nachBankData?.accountHolderName ? nachBankData.accountHolderName : '';
    const bankData: nachBankDetailType = {
      editable: isEditable,
      nachtype,
      accountType,
      branchName,
      accountNumber,
      bankName: nachBankData?.bankName,
      accountHolderName: accountHolderName,
    };

    form.setFieldsValue(bankData);
  }, [nachBankData]);

  // CHANGE 2: Added .length guard protection and case insensitivity to loop evaluations
  useEffect(() => {
    const autoFillBankAndIfsc = async () => {

      console.log("State verification sync snapshot:", { bankNameList, bankName1 });

      if (!bankName1) {
        form.setFieldsValue({ bankName: undefined, branchName: undefined });
        return;
      }

      // Safeguard: Only execute filtering validation if master array contains backend data
      if (bankNameList.length > 0) {
        const bankNameFound = bankNameList.some((item) =>
          item && item.toLowerCase().includes(bankName1.toLowerCase())
        );

        console.log("Match verified:", bankNameFound);

        if (!bankNameFound && !ifscError) {
          const messageErr =
            nachId == 1
              ? 'Ifsc code is not exist for enach banks'
              : 'Ifsc code is not exist for pnach banks';
          message.error(messageErr);
          form.setFieldsValue({ bankName: undefined, branchName: undefined });
          return;
        }
      }

      form.setFieldsValue({
        branchName: branchName || undefined,
        bankName: bankName1 || undefined,
      });
    };

    autoFillBankAndIfsc();
  }, [branchName, bankName1, bankNameList, ifscError, nachId]);
  const handleChange = () => {
    const formData = form.getFieldsValue();
    if (setNachBankData) {
      setNachBankData(formData);
    }
  };

  useEffect(() => {
    if (ifscError)
      form.setFields([
        {
          name: 'ifsc',
          errors: ['Please enter a valid IFSC code!'],
        },
      ]);
  }, [ifscError]);
  // console.log('nachBankData', nachBankData);
  useEffect(() => {
    const autoFillBankAndIfsc = async () => {
      const accountType = nachBankData?.accountType || 'savings'; // Default to savings if undefined
      await form.setFieldsValue({ accountType });
    };
    autoFillBankAndIfsc();
  }, [nachBankData]);

  useEffect(() => {
    // console.log('nachBankData', nachBankData);
  }, [nachBankData]);

  return (
    <div className="mid-container" style={{ position: 'relative' }}>
      <Spin spinning={isLoading}>
        <Form<nachBankDetailType>
          form={form}
          layout="vertical"
          scrollToFirstError
          className="standard-forms"
          initialValues={nachBankData}
          onChange={handleChange}
          disabled={!nachBankData?.editable}
          autoComplete="off"
        >
          <div className="row">
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'IFSC Code:'}
                  rules={[
                    {
                      type: 'string',
                      required: true,
                      len: 11,
                      transform(value) {
                        return value.trim();
                      },
                    },
                  ]}
                  required
                  name="ifsc"
                  className="fieldTitle"
                >
                  <Input
                    autoComplete="off"
                    onChange={(e) => {
                      const upperCaseValue = e.target.value.toUpperCase();
                      setIfscCode(upperCaseValue); // Update state with uppercase value
                      form.setFieldsValue({ ifsc: upperCaseValue });
                    }}
                    minLength={11}
                    maxLength={11}
                    placeholder={'Enter IFSC Code'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Number:'}
                  required
                  name="accountNumber"
                  className="fieldTitle"
                  rules={[
                    ...required,
                    {
                      min: 7,
                      max: 20,
                    },
                  ]}
                >
                  <Input
                    onBeforeInput={handleOnlyDgit}
                    autoComplete="off"
                    placeholder={'Enter Account Number'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>

            {/* <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Number:'}
                  required
                  name="accountNumber"
                  className="fieldTitle"
                  // 🔹 DYNAMIC RULES INTEGRATION FOR DEBOUNCING LIFECYCLE 🔹
                  rules={getAccountValidationRules({
                    nachId: nachId,
                    isEditable: !!nachBankData?.editable,
                    checkLengthApi: checkAccountLengthWithBackend
                  })}
                >
                  <Input
                    onBeforeInput={handleOnlyDgit}
                    autoComplete="off"
                    maxLength={20}
                    placeholder={'Enter Account Number'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div> */}

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                {/* <Form.Item
                  label={'Bank Name :'}
                  rules={required}
                  required
                  name="bankName"
                  className="fieldTitle"
                >
                  <Select size="large" onChange={() => handleChange()} placeholder="Select Bank">
                    {bankNameList.map((bankName) => (
                      <Option key={bankName} value={bankName}>
                        {bankName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item> */}

                <Form.Item
                  label={'Bank Name :'}
                  // Rules can be removed since it is auto-filled
                  name="bankName"
                  className="fieldTitle"
                >
                  <Input

                    readOnly={true} // Set the input field to read-only
                    style={{
                      border: '1px solid #dcdcdc',
                      backgroundColor: '#f5f5f5', // Optionally set a background color to indicate it is not editable
                    }}
                    placeholder="Bank Name"
                  />
                </Form.Item>
              </div>
            </div>

            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Holder Name:'}
                  // required
                  name="accountHolderName"
                  className="fieldTitle"
                  rules={required}
                >
                  <Input
                    placeholder={'Enter Account Holder Name'}
                    maxLength={200}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item>
              </div>
            </div>
            <div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                {/* <Form.Item
                  label={'Branch Name:'}
                  required
                  name="branchName"
                  className="fieldTitle"
                  rules={required}
                >
                  <Input
                    placeholder={'Enter Branch Name'}
                    style={{ border: '1px solid #dcdcdc' }}
                  />
                </Form.Item> */}

                <Form.Item
                  label={'Branch Name:'}
                  // Rules can be removed since it is auto-filled
                  name="branchName"
                  className="fieldTitle"
                >
                  <Input
                    // branchName should be populated from the IFSC lookup logic
                    readOnly={true} // Set the input field to read-only
                    style={{
                      border: '1px solid #dcdcdc',
                      backgroundColor: '#f5f5f5', // Optionally set a background color to indicate it is not editable
                    }}
                    placeholder="Branch Name"
                  />
                </Form.Item>
              </div>
            </div>

            {sourceType !== 'AutoPay' && (<div className="form-group col-xs-12 col-sm-6 col-md-6">
              <div className="input-box">
                <Form.Item
                  label={'Account Type :'}
                  name="accountType"
                  required
                  className="fieldTitle"
                  rules={required}
                >
                  {/* <Radio.Group
                    defaultValue={form.getFieldValue('accountType')?.toLowerCase() || 'savings'}
                  > */}

                  <Radio.Group
                    // 🌟 FIXED: Changed to optional chaining ?.toLowerCase() to prevent execution crashes
                    defaultValue={form.getFieldValue('accountType')?.toString()?.toLowerCase() || 'savings'}
                  >
                    <Radio value="savings">
                      <p style={{ fontSize: '16px', fontWeight: '400' }}>Savings</p>
                    </Radio>
                    <Radio value="current">
                      <p style={{ fontSize: '16px', fontWeight: '400' }}>Current</p>
                    </Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>)}
          </div>
        </Form>
      </Spin>
    </div>
    // </Fade>
  );
}

export default BankDetails;
